require('./bootstrap');

$(document).ready(function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]')
        }
    });

    // Positive message timeout
    setTimeout(function() {
        $('.message.positive').animate({
            height: 'toggle',
            opacity: 'toggle'
        }, 500);
    }, 5000);

    // Fix SVG for older browsers
    svg4everybody();

    // Overlay
    $('.overlay .close').on('click', function(e) {
        e.preventDefault();
        $('.overlaid').removeClass('overlaid');
    });

    // Menu
    $(document).on('click', '[href="#menu"]', function(e) {
        e.preventDefault();
        $('nav .site').toggleClass('active');
    });

    $('nav .site [href="#"]').on('click', function(e) {
        e.preventDefault();
    });

    // Search
    $(document).on('click', '[href="#search"]', function(e) {
        e.preventDefault();
        $('.overlay, #search').addClass('overlaid');
        $('#search input').focus();
    });

    $('#search input').on('keyup', function(event) {
        if (event.keyCode == 27) {
            $('.overlaid').removeClass('overlaid');
        }
    });

    // Accordion
    if ($('.toggle .toggle-title').hasClass('active')) {
        $('.toggle .toggle-title.active').closest('.toggle').find('.toggle-inner').show();
    }

    $('.toggle .toggle-title').click(function() {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active').next('.toggle-inner').slideUp(300);
        } else {
            $(this).addClass('active').next('.toggle-inner').slideDown(300);
        }
    });

    // Default Slick Slider
    $('.default-slider').on('init', function() {
        $(this).removeClass('hidden');
    });

    $('.default-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 4000
    });

    // Convert .svg image to SVG format (add class="svg")
    $('img.svg').each(function() {
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        $.get(imgURL, function(data) {
            // Get the SVG tag, ignore the rest
            var $svg = $(data).find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }

            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Replace image with new SVG
            $img.replaceWith($svg);
        }, 'xml');
    });

    // Locations
    $(document).on('click', '.our-locations .pins li > a', function(e) {
        if ($(window).width() > 568) {
            e.preventDefault();
        }
    });

    // Related Carousels: Industries, Services, Products
    $('.related-carousel ul').each(function() {
        $(this).slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            prevArrow: $(this).parents('.related-carousel').find('.slide-prev'),
            nextArrow: $(this).parents('.related-carousel').find('.slide-next'),
            responsive: [{
                breakpoint: 769,
                settings: {
                    slidesToShow: 3
                }
            }, {
                breakpoint: 451,
                settings: {
                    slidesToShow: 1
                }
            }]
        });
    });
});

function thisURL(params) {
    var url,
        thisURL = document.location.pathname;

    if (params === 1) {
        // option = 1 = full page name with all parameters eg: products.php?id_product=1
        thisURLwithParam = thisURL.substring(0, (thisURL.indexOf('#') == -1) ? thisURL.length : thisURL.indexOf('#'));
        thisURLwithParam = thisURLwithParam.substring(0, getPosition(thisURL, '/', 2));
        url = thisURLwithParam;
    } else {
        // option = null = just the page name (eg: products.php)
        thisURL = thisURL.substring(0, (thisURL.indexOf('#') == -1) ? thisURL.length : thisURL.indexOf('#'));
        thisURL = thisURL.substring(0, (thisURL.indexOf('?') == -1) ? thisURL.length : thisURL.indexOf('?'));
        thisURL = thisURL.substring(0, getPosition(thisURL, '/', 2));
        url = thisURL;
    }

    if (url == '/') {
        url = '/home';
    }

    return url;
}

function thisSubURL(params) {
    var url,
        thisSubURL = document.location.pathname;

    if (params === 1) {
        // option = 1 = full page name with all parameters eg: products.php?id_product=1
        thisURLwithParam = thisSubURL.substring(0, (thisSubURL.indexOf('#') == -1) ? thisSubURL.length : thisSubURL.indexOf('#'));
        thisURLwithParam = thisURLwithParam.substring(0, getPosition(thisSubURL, '/', 3));
        url = thisURLwithParam;
    } else {
        // option = null = just the page name (eg: products.php)
        thisSubURL = thisSubURL.substring(0, (thisSubURL.indexOf('#') == -1) ? thisSubURL.length : thisSubURL.indexOf('#'));
        thisSubURL = thisSubURL.substring(0, (thisSubURL.indexOf('?') == -1) ? thisSubURL.length : thisSubURL.indexOf('?'));
        thisSubURL = thisSubURL.substring(0, getPosition(thisSubURL, '/', 3));
        url = thisSubURL;
    }

    if (url == '/') {
        url = '/home';
    }

    return url;
}

function getPosition(string, subString, index) {
   return string.split(subString, index).join(subString).length;
}
